import React from 'react';
import PropTypes from 'prop-types';
import { Container, Loading } from './styles';

export default function Button({ children, load, size, tamanho }) {
  return (
    <Container size={size} disabled={load} dis={load} tamanho={tamanho}>
      {load ? <Loading /> : children}
    </Container>
  );
}

Button.propTypes = {
  children: PropTypes.string,
  load: PropTypes.bool,
  size: PropTypes.string,
  tamanho: PropTypes.string,
};

Button.defaultProps = {
  children: 'Enviar',
  load: false,
  size: '130px',
  tamanho: '50px',
};
